import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import { AppReducer } from "core/store/reducers/AppReducer";
import { SnackbarsReducer } from "core/store/reducers/SnackbarsReducer";
import { UIReducer } from "core/store/reducers/UIReducer";
import { UserReducer } from "./reducers/UserReducer";
import { OrdersReducer } from "./reducers/OrdersReducer";

export const reducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    app: AppReducer,
    ui: UIReducer,
    snackbars: SnackbarsReducer,
    user: UserReducer,
    orders: OrdersReducer
  });
